import { HttpContextToken } from '@angular/common/http';

// In-memory request lifetime only. Never serialized into headers or browser storage.
export const SCOPED_ACCESS_CURRENT = new HttpContextToken<(() => boolean) | null>(() => null);
